import React from 'react';
import { StyledPaper, StyledTitle } from './styles';

const DisabledModuleMessage = () => (
  <div>
    <StyledPaper>
      <StyledTitle variant="h5" gutterBottom>
        Contact an admin to enable the module
      </StyledTitle>
    </StyledPaper>
  </div>
);

export default DisabledModuleMessage;
